angular.module("Main").filter("filterTimeTB", function () {
    return function (input, timeFrom, timeTill) {
        var result = [];


        //var a = fromA[0]
        if (input.length > 0) {
            _.forEach(input, function (termin) {
                var a = timeFrom.split(":")[0];
                if (a.charAt(0) === "0" && a.charAt(1) !== "0") {
                     a = _.parseInt(a.charAt(1));
                } else {
                    a = _.parseInt(a)
                }
                if (termin.appointment.visible) {
                    let from = timeFrom.split(":");
                    let till = timeTill.split(":");
                    let start = new Date(termin.appointment.Start);
                    let ende = new Date(termin.appointment.End);
                    let timeStart = new Date(start.getFullYear(), start.getMonth(), start.getDate(), from[0], from[1], 0);
                    let timeEnde = new Date(ende.getFullYear(), ende.getMonth(), ende.getDate(), till[0], till[1], 0);

                    if (start.getTime() >= timeStart.getTime() && start.getTime() <= timeEnde.getTime() && ende.getTime() <= timeEnde.getTime()) {
                        result.push(termin)
                    }
                }

                else {

                  //  if (termin.hour >= a) {
                        result.push(termin)
                   // }
                }
            });

        }

        return result;
    };
});